import { useEffect, useRef } from 'react';

export function useTitle(title: string) {
  const documentExists = typeof document !== 'undefined';
  const titleRef = useRef(documentExists ? document.title : null);
  useEffect(() => {
    if (!documentExists) {
      return;
    }
    const ref = titleRef.current;
    if (!ref) {
      return;
    }
    if (document.title !== title) {
      document.title = `${title} - ZEN ID`;
    }
    return () => {
      document.title = ref;
    };
  }, [documentExists, title]);
}
